module.exports = "<div class=product-images__image ng-repeat=\"image in $ctrl.images track by $index\" ng-click=$ctrl.onClickImage()(image) ng-class=\"{'product-images__image--active': $ctrl.activeImage.url === image.url}\" cover-image={{image.url}}> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/product/product-images/product-images.template.html
// module id = 551
// module chunks = 0